import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState, AppThunk } from '../../app/store';

export interface SettingsUiApp {
	leftDrawerDisplay: boolean;
}

export interface SettingsUiPage {
	leftPaneDisplay: boolean;
}

export interface SettingsUi {
	app: SettingsUiApp;
	page: SettingsUiPage;
}

export interface SettingsState {
  ui: SettingsUi;
}

const initialState: SettingsState = {
	ui: {
		app: {
			leftDrawerDisplay: true,
		},
		page: {
			leftPaneDisplay: true,
		},
	}
};

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    toggleUiAppLeftDrawerDisplay: (state) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.ui.app.leftDrawerDisplay = !state.ui.app.leftDrawerDisplay;
    },
  },
});

export const { toggleUiAppLeftDrawerDisplay } = settingsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const selectAppLeftDrawerDisplay = (state: RootState) => {
	return state.settings.ui.app.leftDrawerDisplay;
}

export default settingsSlice.reducer;
